// extracted by mini-css-extract-plugin
export default {"dateRangeWrapper":"style_dateRangeWrapper__1G26M","dateRangeContainer":"style_dateRangeContainer__r3pFv","noteWrapper":"style_noteWrapper__75WuN"};